module.exports = __webpack_public_path__ + "media/src/application/media/bg-img-a88e5b554697e22aace2bc5b3b12284b.jpg";